<template>
  <div class="home-view">
    <!-- Hero Section -->
    <section
      class="hero-section d-flex align-items-center justify-content-center text-center text-white"
    >
      <div class="overlay"></div>
      <div class="content position-relative">
        <h1 class="display-4 fw-bold">Sri Dharma Temple</h1>
        <p class="lead mb-4">
          A sacred place for peace, mindfulness, and compassion
        </p>
        <router-link to="/about" class="btn btn-light px-4 py-2 fw-bold"
          >Learn More</router-link
        >
      </div>
    </section>

    <!-- Welcome Section -->
    <section class="welcome-section py-5 bg-light">
      <div class="container text-center">
        <h2 class="fw-bold text-gold mb-4">Welcome to Our Temple</h2>
        <p class="text-muted mb-5">
          The Sri Dharma Temple is a serene sanctuary where devotees come
          together to practice mindfulness, learn the Dhamma, and cultivate
          loving-kindness under the guidance of venerable monks.
        </p>
        <img
          src="@/assets/temple-inside.jpg"
          alt="Temple Inside"
          class="img-fluid rounded shadow-sm"
          style="max-width: 700px"
        />
      </div>
    </section>

    <!-- Featured Events -->
    <section class="events-section py-5">
      <div class="container text-center">
        <h2 class="fw-bold text-gold mb-4">Upcoming Events</h2>
        <div class="row g-4">
          <div class="col-md-4" v-for="(event, index) in events" :key="index">
            <div class="card border-0 shadow-sm h-100">
              <img :src="event.image" class="card-img-top" :alt="event.title" />
              <div class="card-body">
                <h5 class="fw-bold text-gold">{{ event.title }}</h5>
                <p class="text-muted small mb-2">
                  <i class="bi bi-calendar-event me-1"></i> {{ event.date }}
                </p>
                <p class="card-text text-muted">
                  {{ event.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <router-link to="/events" class="btn btn-gold mt-4 px-4 fw-bold"
          >View All Events</router-link
        >
      </div>
    </section>

    <!-- Donation Call -->
    <section class="donation-section text-center text-white py-5">
      <div class="overlay"></div>
      <div class="container position-relative">
        <h2 class="fw-bold mb-3">Support the Temple</h2>
        <p class="mb-4">
          Help us preserve the teachings of the Buddha and maintain this sacred
          space for generations to come.
        </p>
        <router-link to="/donations" class="btn btn-light px-4 py-2 fw-bold"
          >Make a Donation</router-link
        >
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      events: [
        {
          title: "Full Moon Meditation",
          date: "November 15, 2025",
          description:
            "Join our full moon day meditation and Dhamma sermon with the chief monk.",
          image: require("@/assets/meditation.jpg"),
        },
        {
          title: "Annual Katina Ceremony",
          date: "December 5, 2025",
          description:
            "Celebrate the Katina festival and offer robes to the Sangha with blessings.",
          image: require("@/assets/katina.jpg"),
        },
        {
          title: "Vesak Festival",
          date: "May 12, 2026",
          description:
            "Experience the beauty of Vesak with lanterns, Dhamma sermons, and almsgiving.",
          image: require("@/assets/vesak.jpg"),
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Gold Color */
.text-gold {
  color: #c69f59;
}

/* 🕉 Hero Section */
.hero-section {
  height: 90vh;
  background: url("@/assets/temple-hero.jpg") center center/cover no-repeat;
  position: relative;
}
.hero-section .overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.hero-section .content {
  z-index: 2;
}
.hero-section h1 {
  font-size: 3rem;
}
.hero-section p {
  font-size: 1.25rem;
}

/* 🏯 Welcome Section */
.welcome-section img {
  width: 100%;
  max-width: 700px;
}

/* 🌼 Events Section */
.card img {
  height: 230px;
  object-fit: cover;
}
.card-body {
  padding: 1rem 1.25rem;
}
.btn-gold {
  background-color: #f6d57a;
  color: #4a3200;
  border: none;
  transition: 0.3s;
}
.btn-gold:hover {
  background-color: #ffeaa7;
  color: #3a2700;
}

/* 🙏 Donation Section */
.donation-section {
  background: url("@/assets/donation-bg.jpg") center center/cover no-repeat;
  position: relative;
}
.donation-section .overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.donation-section .container {
  z-index: 2;
  position: relative;
}

/* 📱 RESPONSIVE STYLES */
@media (max-width: 991px) {
  .hero-section {
    height: 75vh;
  }
  .hero-section h1 {
    font-size: 2.2rem;
  }
  .hero-section p {
    font-size: 1rem;
  }
  .btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem !important;
  }
  .welcome-section h2 {
    font-size: 1.75rem;
  }
  .welcome-section p {
    font-size: 0.95rem;
    padding: 0 10px;
  }
  .events-section h2 {
    font-size: 1.75rem;
  }
  .card img {
    height: 200px;
  }
  .donation-section h2 {
    font-size: 1.8rem;
  }
  .donation-section p {
    font-size: 1rem;
    padding: 0 15px;
  }
}

@media (max-width: 576px) {
  .hero-section {
    height: 70vh;
  }
  .hero-section h1 {
    font-size: 1.8rem;
  }
  .hero-section p {
    font-size: 0.9rem;
    margin-bottom: 1.2rem;
  }
  .btn {
    font-size: 0.85rem;
  }
  .welcome-section h2,
  .events-section h2,
  .donation-section h2 {
    font-size: 1.5rem;
  }
  .text-gold {
    font-size: 1rem;
  }
}
</style>
